import {react,useEffect, useState} from "react";
import Container from "./Container";
import EditText from "./EditText";
import Button from "./Button";
import { useReducer } from "react";
import { reducer,initialState } from "../reducers/reducers";
import Table1 from "./Table1";
import NewUser from "./NewUser";
import ViewUser from "./ViewUser";
import Urls from "../Urls";
import { useAuth } from "./AuthProvider";

const Users = () =>{
    const { canWrite, canRead } = useAuth();
    const [data,setData] = useState([])
    const [state, dispatch] = useReducer(reducer, initialState);
    const [viewUser,setViewUser] = useState({})
    const [fullData,setFullData] = useState([])
    // Estados para paginación
    const [page, setPage] = useState(1);
    const [perPage] = useState(20); // Fijo a 20
    const [lastPage, setLastPage] = useState(1);
    const [total, setTotal] = useState(0);
    // Estados para búsqueda
    const [searchText, setSearchText] = useState("");
    const [isSearching, setIsSearching] = useState(false);
    const [searchResults, setSearchResults] = useState([]);

    const transformData = (data) => {
        return(data.map(item => {
            // Initialize an empty array for each transformed dictionary
            const newArray = [];
            
            // Conditionally add parameters
            newArray.push(item.user_id)
            newArray.push(item.usuario)
            newArray.push(item.nombre)
            newArray.push(item.is_active);
            newArray.push(item.fecha_creacion);
            newArray.push(item.email)
            newArray.push(item.telefono)
            return newArray;
          }))
          
    }
    const fetchData = (url) => {
        // Verificar permisos de lectura
        if (!canRead('acceso_notas_recepcion')) {
            console.error('No tienes permisos para ver estos datos');
            alert('No tienes permisos para ver estos datos');
            setFullData([]);
            setData([]);
            setLastPage(1);
            setTotal(0);
            return Promise.reject('No tienes permisos para ver estos datos');
        }

        // Agregar parámetros de paginación
        const paginatedUrl = `${url}?page=${page}&per_page=${perPage}`;
        console.log(`Solicitando datos: ${paginatedUrl}`);
        
        fetch(paginatedUrl, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        })
        .then(response => {
            if (!response.ok) {
                throw new Error('Network response was not ok ' + response.statusText);
            }
            
            return response.json();
        })
        .then(result => {
            // Si la respuesta es paginada
            if (result && result.data && result.page !== undefined) {
                console.log(`Respuesta paginada: ${result.data.length} elementos, página ${result.page} de ${result.last_page}, total: ${result.total}`);
                setFullData(result.data);
                setData(transformData(result.data));
                setLastPage(result.last_page);
                setTotal(result.total);
            } else {
                // Respaldo para respuesta no paginada
                const dataArray = Array.isArray(result) ? result : [];
                console.log(`Respuesta no paginada: ${dataArray.length} elementos`);
                setFullData(dataArray);
                
                // Aplicar paginación local
                const calculatedLastPage = Math.ceil(dataArray.length / perPage) || 1;
                console.log(`Calculando paginación local: ${calculatedLastPage} páginas`);
                
                // Aplicar paginación local a los datos transformados
                const startIndex = (page - 1) * perPage;
                const endIndex = Math.min(startIndex + perPage, dataArray.length);
                const paginatedData = dataArray.slice(startIndex, endIndex);
                
                setData(transformData(paginatedData));
                setLastPage(calculatedLastPage);
                setTotal(dataArray.length);
            }
        })
        .catch(error => {
            console.error('There was a problem with the fetch operation:', error);
            setFullData([]);
            setData([]);
            setLastPage(1);
            setTotal(0);
        });
    }

    useEffect(()=>{
        if (isSearching) {
            // Si estamos buscando, aplicamos paginación local a los resultados de búsqueda
            const startIndex = (page - 1) * perPage;
            const endIndex = Math.min(startIndex + perPage, searchResults.length);
            const paginatedData = searchResults.slice(startIndex, endIndex);
            
            setData(transformData(paginatedData));
            setLastPage(Math.ceil(searchResults.length / perPage) || 1);
            setTotal(searchResults.length);
        } else {
            // Si no estamos buscando, obtenemos datos normales
            fetchData(Urls.GET_USERS);
        }
    }, [page, isSearching, searchResults])

    // Controles de paginación
    function PaginationControls() {
        // Estilos para los botones
        const buttonStyle = {
            backgroundColor: '#7AACE3',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            padding: '8px 16px',
            margin: '0 5px',
            cursor: 'pointer',
            fontWeight: 'bold',
            transition: 'background-color 0.3s'
        };

        const disabledButtonStyle = {
            ...buttonStyle,
            backgroundColor: '#cccccc',
            cursor: 'not-allowed',
            opacity: 0.7
        };

        return (
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '15px 0' }}>
                <button 
                    onClick={() => setPage(prev => Math.max(prev - 1, 1))} 
                    disabled={page === 1}
                    style={page === 1 ? disabledButtonStyle : buttonStyle}
                >
                    &lt; Anterior
                </button>
                <span style={{ margin: '0 15px', fontWeight: 'bold' }}>
                    Página {page} de {lastPage} ({total} registros)
                </span>
                <button 
                    onClick={() => setPage(prev => Math.min(prev + 1, lastPage))} 
                    disabled={page === lastPage}
                    style={page === lastPage ? disabledButtonStyle : buttonStyle}
                >
                    Siguiente &gt;
                </button>
            </div>
        );
    }

    // Función para manejar la búsqueda
    const handleSearch = () => {
        // Validar permisos de lectura
        if (!canRead('acceso_notas_recepcion')) {
            console.error('No tienes permisos para ver estos datos');
            alert('No tienes permisos para ver estos datos');
            setSearchResults([]);
            setLastPage(1);
            setTotal(0);
            return Promise.reject('No tienes permisos para ver estos datos');
        }

        if (!searchText.trim()) {
            // Si el texto de búsqueda está vacío, no hacemos nada
            return;
        }
        
        setIsSearching(true);
        setPage(1); // Reiniciar a la primera página
        
        // Filtrar los datos completos según el texto de búsqueda
        const results = fullData.filter(user => {
            const searchLower = searchText.toLowerCase();
            return (
                (user.usuario && user.usuario.toLowerCase().includes(searchLower)) ||
                (user.nombre && user.nombre.toLowerCase().includes(searchLower)) ||
                (user.email && user.email.toLowerCase().includes(searchLower))
            );
        });
        
        setSearchResults(results);
        console.log(`Búsqueda: ${searchText} - ${results.length} resultados encontrados`);
    };
    
    // Función para limpiar la búsqueda
    const clearSearch = () => {
        setSearchText("");
        setIsSearching(false);
        setPage(1); // Reiniciar a la primera página
        fetchData(Urls.GET_USERS); // Cargar datos normales
    };

    return (
    <div className="anylayout">
        <div className="titleFont">Usuarios</div>
            <Container>
                <div style={{ display: 'flex', alignItems: 'center', marginRight: '10px' }}>
                    <EditText 
                        text="Buscar..." 
                        value={searchText}
                        onChange={(e) => setSearchText(e.target.value)}
                        onKeyPress={(e) => {
                            if (e.key === 'Enter') {
                                handleSearch();
                            }
                        }}
                    />
                    <Button text="Buscar" onClick={handleSearch} color="#7AACE3" />
                    {isSearching && (
                        <Button text="Limpiar búsqueda" onClick={clearSearch} color="#DF7476" />
                    )}
                </div>
                {canWrite('acceso_notas_recepcion') && (
                <Button text="Agregar usuario" onClick={()=>{dispatch({ type: 'openNewUser' })}} color="#7AACE3" />
                )}
            </Container>
            {isSearching && (
                <div style={{ textAlign: 'center', margin: '10px 0', fontStyle: 'italic' }}>
                    Mostrando resultados de búsqueda para: "{searchText}" ({searchResults.length} resultados)
                </div>
            )}
            <PaginationControls />
            <Table1 optview={true} data={data} onClickView={(data)=>{dispatch({ type: 'openViewUser' });setViewUser(Object.values(fullData).find(user => user.user_id === data.at(0)) || {})}} headers={['id','username','Nombre','Activo?','Fecha/creacion','email','telefono']} ></Table1>
            <PaginationControls />
            {
                state.statusViewUser && (
                    <ViewUser user_id={viewUser.user_id} onClose={()=>dispatch({ type: 'closeViewUser' })}></ViewUser>
                )
            }
            {
                state.statusNewUser && (
                    <NewUser onAccept={()=>{dispatch({ type: 'closeNewUser' });fetchData(Urls.GET_USERS)}} onClose={()=>dispatch({ type: 'closeNewUser' })}></NewUser>
                )
            }
    </div>
    )}
export default Users;